import { axiosClient } from "../axios";

const baseUrl = (firmId) => `/api/docs/firms/${firmId}/images`;

export function getActiveImageUrl(firmId) {
  return axiosClient.get(`${baseUrl(firmId)}/active/url`);
}

export function remove(firmId, imageId) {
  return axiosClient.delete(`${baseUrl(firmId)}/${imageId}`);
}

export function getUploadUrl(firmId, data) {
  return axiosClient.post(`${baseUrl(firmId)}/upload-url`, data);
}

export function confirmUpload(firmId, data) {
  return axiosClient.post(`${baseUrl(firmId)}`, data);
}
